<template>
  <div class="xcard">
    <h3 class="text-primary text-center">Sedes Registradas en el Sistema.</h3>
    <p v-if="!$store.state.isonlyread && $store.state.CARGO.id != 11 && $store.state.CARGO.id != 12 && $store.state.CARGO.id != 13" class="text-right">
      <router-link to="sedesadd" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-plus"></span> Registrar Nueva Sede</router-link>
      <!-- <router-link to="dosificaciones" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-plus"></span> Dosificaciones</router-link> -->
      <router-link to="nits" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-plus"></span> Numeros Nits</router-link>
      <!-- <router-link to="sucursales" class="btn btn-sm btn-link"> <span class="glyphicon glyphicon-plus"></span> Sucursales</router-link> -->
    </p>

    <label> <input type="checkbox" v-model="contraercolumnas" /> Contraer columnas <small>(Oculta las columnas no necesarias)</small> </label>

    <div class="table-responsive">
      <table class="table table-hover">
        <thead style="background: #196391">
          <tr class="white--text">
            <th>Nro</th>
            <th>Sede</th>
            <th>Ciudad</th>
            <th v-show="!contraercolumnas">Direccion</th>
            <th v-show="!contraercolumnas">Telefono 1</th>
            <th v-show="!contraercolumnas">Telefono 2</th>
            <th v-show="!contraercolumnas">Fijo</th>
            <th v-show="!contraercolumnas">Aulas</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(sede, ind) in datos">
            <td>{{ ind + 1 }}</td>
            <td :title="'id:' + sede.id">{{ sede.nombre }}</td>
            <td>{{ parseCiudad(sede.ciudad) }}</td>
            <td v-show="!contraercolumnas">{{ sede.direccion }}</td>
            <td v-show="!contraercolumnas">{{ sede.telefono1 }}</td>
            <td v-show="!contraercolumnas">{{ sede.telefono2 }}</td>
            <td v-show="!contraercolumnas">{{ sede.telefono_fijo }}</td>
            <td v-show="!contraercolumnas">{{ parseAulas(sede.aulas) }}</td>
            <td style="min-width: 90px">
              <button @click="selecionar(sede)" class="btn btn-sm btn-default" title="Mapa" data-toggle="modal" data-target="#modal-mapa">
                <span class="glyphicon glyphicon-map-marker"></span>
              </button>
              <button v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == -6" @click="editarSede(sede)" class="btn btn-sm btn-default" title="Editar Datos">
                <span class="glyphicon glyphicon-pencil"></span>
              </button>
              <button v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 8" @click="$router.push('/sucursalesbysede?idsede='+sede.id)" class="btn btn-sm btn-default" title="Ver sucursales">
                <span class="glyphicon glyphicon-globe"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div id="mapa" style="width: 100%; height: 80%"></div> -->
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="modal-mapa">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title text-center">Ubicacion {{ seleccionado.nombre }}</h4>
          </div>
          <div class="modal-body">
            <div id="mapa" style="width: 100%; height: 400px"></div>
          </div>

          <div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button></div>
        </div>
      </div>
    </div>

    <Alertas ref="alertar" />
  </div>
</template>



<script>
import Alertas from '@/components/AAlertas.vue';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      mapa: null,
      contraercolumnas: true,
      seleccionado: { nombre: '' },
      negocio: process.env.VUE_APP_NAME,
    };
  },
  components: { Alertas },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      // reload filter();
    },
    seleccionado: function () {
      if (this.seleccionado.latitud) {
        var thiz = this;
        this.mapa.setZoom(18);
        this.mapa.setCenter({ lat: this.seleccionado.latitud, lng: this.seleccionado.longitud });

        /* var marker =  */ new window.google.maps.Marker({
          position: { lat: thiz.seleccionado.latitud, lng: thiz.seleccionado.longitud },
          map: thiz.mapa,
          title: 'Hello World!',
        });
      } else {
        this.mapa.setZoom(5);
        this.mapa.setCenter({ lat: -17.082262, lng: -63.576108 });
      }
    },
  },
  computed: {
    ...mapState({
      datos: (state) => (state.UNIDAD_NEGOCIO_ID ? state.modsede.items.filter((item) => item.unidad_negocio == state.UNIDAD_NEGOCIO_ID) : []),
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  methods: {
    parseCiudad(c) {
      if (c == null) return '';
      var dep = c.departamento;
      if (dep) return c.nombre + ' (' + dep.nombre + ')';
      return c.nombre;
    },
    parseAulas(a) {
      if (a == null) return 0;
      return a.length;
    },
    selecionar(sel) {
      this.seleccionado = sel;
    },
    editarSede(sede) {
      window.sessionStorage.setItem('xsede', JSON.stringify(sede));
      this.$router.push({ name: 'sedesmod' });
    },
    iniciarMapa() {
      var mapita = document.getElementById('mapa');
      this.mapa = new window.google.maps.Map(mapita, {
        center: { lat: -17.082262, lng: -63.576108 },
        zoom: 5,
      });
    },
  },
  mounted() {
    this.iniciarMapa();
    
  },
};
</script>